angular.module('impactx.approval').directive('appDeniedApprovalItem', function() {
    return {
        scope: {
            item: '=',
            selectedItems: '=',
            trns: '=',
            showNet: "=",
            showGross: "=",
            showComments: "=",
            selectedSupplier: "=",
            showCatalogNet: "="
        },
        restrict: 'E',
        templateUrl: 'modules/approval/templates/deniedapprovalitem.tmpl.html',
        transclude: true
    };
});